import { useState } from "react";
import { Modal } from "@mantine/core";
import { IconBrandDiscord, IconX } from "@tabler/icons-react";

export function Footer() {
  const [kofiOpen, setKofiOpen] = useState(false);
  const year = new Date().getFullYear();

  return (
    <>
      <footer className="mt-auto border-t border-[color:var(--color-border)] bg-[color:var(--color-bg)]">
        <div className="mx-auto flex max-w-5xl flex-col items-center justify-between gap-3 px-4 py-6 text-sm text-[color:var(--color-fg-dim)] sm:flex-row">
          <span>
            {"©"} {year} Nifusion.dev
          </span>

          <div className="flex items-center gap-2">
            <a
              href="discord://-/users/317065077268283392"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-1.5 rounded-full border border-[color:var(--color-border)] px-3 py-1.5 text-[color:var(--color-fg-muted)] transition-colors hover:border-[color:var(--color-accent)] hover:text-[color:var(--color-accent)]"
            >
              <IconBrandDiscord size={15} />
              Discord
            </a>
            <button
              type="button"
              onClick={() => setKofiOpen(true)}
              className="inline-flex items-center gap-1.5 rounded-full border border-[color:var(--color-border)] px-3 py-1.5 text-[color:var(--color-fg-muted)] transition-colors hover:border-[color:var(--color-accent)] hover:text-[color:var(--color-accent)]"
            >
              <span aria-hidden>{"☕"}</span>
              Buy me a coffee
            </button>
          </div>
        </div>
      </footer>

      <Modal
        opened={kofiOpen}
        onClose={() => setKofiOpen(false)}
        centered
        size="lg"
        withCloseButton={false}
        padding={0}
        styles={{
          content: { overflow: "visible" },
          body: { overflow: "visible", padding: 0 },
        }}
      >
        <div className="relative">
          <button
            type="button"
            onClick={() => setKofiOpen(false)}
            aria-label="Close"
            className="absolute -right-2 -top-2 z-10 inline-flex h-6 w-6 items-center justify-center rounded-full border border-[color:var(--color-border)] bg-[color:var(--color-panel)] text-[color:var(--color-fg)] shadow-sm hover:border-[color:var(--color-accent)] hover:text-[color:var(--color-accent)]"
          >
            <IconX size={14} />
          </button>
          <iframe
            title="Ko-fi"
            src="https://ko-fi.com/nifusion/?hidefeed=true&widget=true&embed=true"
            className="h-[720px] w-full rounded-lg border-0"
          />
        </div>
      </Modal>
    </>
  );
}
